// extracted by mini-css-extract-plugin
export default {"color":"topbar_color__2mD2J"};